import { FormControl } from "@angular/forms";


export function validarNumeroPositivo(control: FormControl) {
    
    if (control.value < 0) {
       return {numeroPositivo: {
                 valid: false
                }}
    }
    return null;
  }


// WEBPACK FOOTER //
// ./src/app/utils/validators/validators.ts